import { render } from "./ConfigurableCompanyRow.vue?vue&type=template&id=681c8b9e"
import script from "./ConfigurableCompanyRow.vue?vue&type=script&lang=js"
export * from "./ConfigurableCompanyRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__